import { patterns } from '../settings';

// static validators
export const isNumeric = (value: string) => patterns.NUMERIC_STRING.test(value);

// dynamic validators
export const startsWith = (prefix: string, value: string) => value.startsWith(prefix);
